import React from "react";
import {useTranslation} from "react-i18next";
import SummaryItem from "../../../components/Summary/SummaryItem";
import CustomTooltip from "../../../components/CustomTooltip";
import {IconPlusFill} from "../../../components/buttons/IconButtons";

/**
 * Last place of a summary section with more items than it shows: the "+N" of the ones left out,
 * as the summary list card does. Hovering it lists the items left out, each one with its value.
 *
 * @param {string} label Translation key of the label, the total added of the section.
 * @param {Array<{label: string, value: string}>} hiddenItems Items left out, their name and value.
 */
const SummaryOverflowItem = ({label, hiddenItems = []}) => {
    const {t} = useTranslation();

    return (
        <SummaryItem
            label={label}
            className={'background-shades-100 justify-content-between'}
            classNameValue={'d-flex justify-content-end'}
            value={
                <div className={"col-12 d-flex justify-content-end p-0 pr-3"}>
                    <CustomTooltip
                        text={
                            <div className={"d-flex flex-column gap-9px"}>
                                {hiddenItems.map((item, index) => (
                                    <div key={index} className={"d-flex flex-column"}>
                                        <span className={"ibl-font-w-600"}>{item.label}</span>
                                        {item.value && <span>{item.value}</span>}
                                    </div>
                                ))}
                            </div>
                        }
                        placement={'top'}
                    >
                        <div className={"d-flex align-items-baseline"}>
                            <div className={"mr-8px"}><IconPlusFill/></div>
                            <p className={"fs-14px "}>{hiddenItems.length}</p>
                        </div>
                    </CustomTooltip>
                </div>
            }
            t={t}
        />
    );
};

export default SummaryOverflowItem;
